<template>
  <div class="print-container" id="print-container">
    <h1>{{ $t('page_plan_process_flow_card') }}</h1>
    <table>
      <tr>
        <td>{{ $t('page_plan_production_plan_no') }}</td>
        <td>{{ cardPrintData.code }}</td>
        <td>{{ $t('page_plan_order_no') }}</td>
        <td>{{ cardPrintData.orderCode }}</td>
      </tr>
      <tr>
        <td>{{ $t('page_product_name') }}</td>
        <td>{{ $t('page_plan_product_no') }}</td>
        <td>{{ $t('page_plan_stardard_model') }}</td>
        <td>{{ $t('page_plan_craft_version') }}</td>
      </tr>
      <tr>
        <td>{{ cardPrintData.productionName }}</td>
        <td>{{ cardPrintData.productionCode }}</td>
        <td>{{ cardPrintData.standardModel }}</td>
        <td>{{ cardPrintData.version }}</td>
      </tr>
      <tr>
        <td>{{ $t('page_plan_craft_name') }}</td>
        <td>{{ $t('page_plan_craft_sort') }}</td>
        <td>{{ $t('page_plan_barcode') }}</td>
        <td>{{ $t('page_plan_procedure_number') }}</td>
      </tr>
      <tr :key="index" v-for="(item, index) in cardPrintData.productionOrderProcessBO">
        <td>{{ item.processName }}</td>
        <td>{{ item.sort }}</td>
        <td>
          <img style="max-width: 260px; max-height: 170px;" :id="'barcode' + item.sort" />
        </td>
        <td>{{ item.programName }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import jsbarcode from 'jsbarcode'

export default {
  computed: {
    ...mapGetters(['cardPrintData'])
  },
  data() {
    return {}
  },
  mounted() {
    this.cardPrintData.productionOrderProcessBO.forEach((item) => {
      const options = {
        text: this.cardPrintData.orderCode + '-' + item.sort + '-' + item.processCode
      }
      jsbarcode('#barcode' + item.sort, item.id, options)
    })
    setTimeout(() => {
      window.print()
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.print-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 940px;
  // margin: 64px 0;
  padding: 40px 16px 0;
  h1 {
    font-size: 30px;
    padding-bottom: 18px;
  }
  table {
    width: 100%;
    font-size: 20px;
    border: 4px solid #000;
    // font-weight: 700;
    tbody {
      width: 100%;
    }
    tr {
      td {
        min-width: 180px;
        padding: 8px;
        text-align: center;
        color: #000;
        border: 2px solid #000;
        overflow-wrap: break-word;
        &:nth-child(1),
        &:nth-child(2) {
          max-width: 320px;
        }
        &:nth-child(3),
        &:nth-child(4) {
          max-width: 300px;
        }
      }
    }
  }
}
@page {
  size: portrait;
}
</style>
